
import React from "react";
import { Field, useField } from "formik";
import styles from "./controllers.module.css";
import Asterisk from "../../../../../components/asterisk/Asterisk";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from "../../../../../components/label/Labels";
import DropDown from "../../../../../components/dropDown/DropDown";
import { FieldWrapper } from "../../../../../components/Section/Section";
import { FormTextArea, TextInput } from "../../../../../components/input/inputs";
import FileUploadAttachment from "../../../../../components/fileUpload/fileUpload.container";
import FileAttachment from "../../../../../components/fileAttachment/fileAttachment.container";

export const RadioGroupField = ({
  label,options = [],isPreviewMode = false,disabled = false,direction = "vertical",required = true,...props
}) => {
  const [field, meta, helpers] = useField(props);
  const hasError = !!meta.error &&(meta.touched || (field.value && String(field.value).trim() !== ""));

  return (
    <div className={styles.fieldWrapper}>
      <div className={styles.labelRow}>
        <label className={styles.label}>{label}</label><Asterisk/>
      </div>
      {!isPreviewMode ? (
        <div className={`${styles.radioGroup} ${ direction === "horizontal" ? styles.horizontal: styles.vertical }`}>
          {options.map((opt) => (
            <label key={opt.value} className={styles.radioLabel}>
              <input
                type="radio"
                name={field.name}
                value={opt.value}
                checked={field.value === opt.value}
                onChange={() => helpers.setValue(opt.value)}
                onBlur={() => helpers.setTouched(true)}
                disabled={disabled}
                aria-checked={field.value === opt.value}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
      ) : (
        <div className={styles.previewText}>
          {options.find((o) => o.value === field.value)?.label || "---"}
        </div>
      )}
      {hasError && <div className={styles.error}>{meta.error}</div>}
    </div>
  );
};

export const TextField = ({ label, disabled, isPreviewMode = false, ...props }) => {
  const [field, meta] = useField(props);
  const hasError = (!!meta.error && (meta.touched || (field.value && String(field.value).trim() !== "")));
  const inputStyle = hasError ? `${styles.input} ${styles.inputError}` : styles.input;

  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
        <Asterisk />
      </div>
      {
        !isPreviewMode ?
            <TextInput {...field} {...props} style={inputStyle} disabled={disabled} />
           :
          <div className={styles.previewText}>
            {field?.value ? field?.value : "---"}
          </div>
      }
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};

// export const SelectField = ({ title, options = [], customStyles, isDisabled, onChange = () => { }, ...props }) => {
//   const [field, meta, helpers] = useField(props);
//   const hasError = meta.touched && !!meta.error;

//   const currentValue =
//     options?.length > 0 && field?.value
//       ? options.find((opt) => opt.value === field.value) || null
//       : null;

//   return (
//     <FieldWrapper>
//       <div>
//         <Label text={title} />
//         <Asterisk />
//       </div>
//       <DropDown
//         options={options}
//         onChange={({ label, value }) => {
//           onChange(value);
//           helpers.setValue(value);
//         }}
//         value={currentValue}
//         hasError={hasError}
//         isDisabled={isDisabled}
//         customStyles={customStyles}
//       />
//       {hasError ? <ErrorLabel text={meta.error} /> : null}
//     </FieldWrapper>
//   );
// };
export const SelectField = ({ title,customStyles, options, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  return (
    <FieldWrapper>
      <div>
        <Label text={title} /><Asterisk />
      </div>
      <DropDown
        options={options}
        onChange={({ label, value }) => {
          props.onChange(value);
          helpers.setValue(value);
        }}
        value={
          ((options?.length > 0) && field.value)
            ? options.find((option) => option.value === field.value)
            : ""
        }
        hasError={hasError}
        isDisabled={props.isDisabled}
         customStyles={customStyles}
      />
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};
export const TextArea = ({ label, optional = false,maxlength, ...props }) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && !!meta.error;
  const inputStyle = hasError ? `${styles.input} ${styles.inputError}` : styles.input;

  return (
    <FieldWrapper>
      <Label text={label} optional={optional} />
      <FormTextArea {...field} {...props} style={inputStyle} />
      <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
          {hasError ? <ErrorLabel text={meta.error} /> : null}   
          {maxlength ?? <label >{maxlength}</label>}
      </div>
    </FieldWrapper>
  );
};

export const ImageUpload = ({ setFieldValue, value, label, isvolte = false, ...props }) => {
  const [, meta] = useField(props);
  const hasError = meta.touched && !!meta.error;

  return (
    <FieldWrapper>
      <div style={{ display: "flex", gap: 6 }}>
        <Label text={label} optional={false} />
        {label === "Attachment IR21" && <Asterisk />}
      </div>
        <FileUploadAttachment
          setFieldValue={setFieldValue}
          name={props.name}
          value={value}
          displayMessage={props?.displayMessage}
          maxFileSize={props?.maxFileSize}
          maxFileSizeTXT={props?.maxFileSizeTXT}
          combineFilesMaxSize={props?.combineFilesMaxSize}
          combineFilesMaxSizeTXT={props?.combineFilesMaxSizeTXT}
          numOfFilesAllowToUpload={props?.numOfFilesAllowToUpload}
          errorMessageForNumberOfFiles={props?.errorMessageForNumberOfFiles}
          acceptFileType={props?.acceptFileType}
        />
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};

export const CheckBox = (name, ...props) => {

  return (
      <div className={styles.checkboxsWrapper}>
        <Field className={styles.checkboxs} type="checkbox" name={name.name} value={name.value} />
        <span className={styles.label}>{name.label}</span>
      </div>
  )
}